// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-background {
  width: 100% !important;
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
}

.logo {
  margin: 0 auto;
}

.invent-logo {
  width: 150px;
  margin: 0 auto;
  display: block;
}

.banner-logo {
  width: 100%;
  margin: 0 auto;
  display: block;
  max-width: 600px;
  position: relative;
}

ion-title {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  text-transform: uppercase;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media screen and (min-width: 768px) {
  .web-layout {
    position: relative;
    width: 100%;
    min-height: 100vh;
    display: flex;
  }
  .web-bg {
    position: fixed;
    inset: 0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  .web-bg__overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, rgba(0, 0, 0, 0.55) 0%, rgba(0, 0, 0, 0.15) 50%, rgba(0, 0, 0, 0.6) 100%);
  }
  .web-bg__content {
    position: absolute;
    inset: 0;
    right: 560px;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 80px 0 80px 72px;
  }
  .web-bg__marketing {
    max-width: 560px;
  }
  .web-bg__logo {
    max-width: 180px;
    max-height: 72px;
    object-fit: contain;
    margin-bottom: 48px;
  }
  .web-bg__headline {
    font-family: "Roobert-Bold", sans-serif;
    font-size: 2.4em;
    color: #ffffff;
    margin: 0 0 48px;
    line-height: 1.25;
  }
  .web-bg__features {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 28px;
  }
  .web-bg__feature {
    display: flex;
    gap: 18px;
    align-items: flex-start;
  }
  .web-bg__feature ion-icon {
    font-size: 2em;
    color: rgba(255, 255, 255, 0.75);
    margin-top: 2px;
    flex-shrink: 0;
  }
  .web-bg__feature strong {
    display: block;
    font-family: "Roobert-Bold", sans-serif;
    font-size: 1.15em;
    color: #ffffff;
    margin-bottom: 4px;
  }
  .web-bg__feature p {
    font-family: "Roobert-Regular", sans-serif;
    font-size: 1em;
    color: rgba(255, 255, 255, 0.6);
    margin: 0;
    line-height: 1.55;
  }
  .web-panel {
    position: relative;
    z-index: 1;
    width: 560px;
    min-width: 560px;
    min-height: 100vh;
    margin-left: auto;
    display: flex;
    flex-direction: column;
    animation: fadeInUp 0.5s ease forwards;
  }
  .web-panel__inner {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 48px 56px;
  }
  .web-panel__scroll {
    width: 100%;
    max-width: 400px;
    margin: 0 auto;
  }
  .web-panel__top {
    margin-bottom: 32px;
  }
  .web-panel__logo {
    max-width: 100px;
    max-height: 44px;
    object-fit: contain;
    margin-bottom: 28px;
  }
  .web-panel__title {
    font-family: "Roobert-Bold";
    font-size: 1.65em;
    color: #ffffff;
    margin: 0 0 8px;
    line-height: 1.3;
  }
  .web-panel__desc {
    font-family: "Roobert-Regular";
    font-size: 0.95em;
    color: rgba(255, 255, 255, 0.7);
    margin: 0;
    line-height: 1.5;
  }
  .web-panel__body {
    width: 100%;
  }
  .web-panel__body ion-grid {
    --ion-grid-padding: 0;
  }
  .web-panel__body ion-row {
    padding-left: 0;
    padding-right: 0;
  }
  .web-panel__body ion-col {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin-left: 0 !important;
  }
  .web-panel__body .padding-top-40 {
    padding-top: 0;
  }
  .web-panel__body .btn-default {
    width: 100%;
    max-width: 100%;
  }
  .web-panel__body .color-1st-screen {
    color: #ffffff;
  }
  .web-panel__body .color-1st-screen a {
    color: #ffffff !important;
  }
  .web-panel__body .forgot-password {
    color: rgba(255, 255, 255, 0.8);
  }
  .web-panel__body .term-conditions {
    justify-content: flex-start;
    gap: 2px;
  }
  .web-panel__body ::ng-deep .login-form {
    width: 100%;
  }
  .web-panel__body ::ng-deep .login-form__header {
    margin-bottom: 28px;
  }
  .web-panel__body ::ng-deep .login-form__field {
    margin-bottom: 16px;
  }
  .web-panel__body ::ng-deep .login-form__actions {
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .web-panel__body ::ng-deep .login-title {
    font-family: "Roobert-Bold", sans-serif;
    font-size: 1.35em;
    color: #ffffff;
    margin: 0;
    text-align: left;
  }
  .web-panel__body ::ng-deep .explanation-txt {
    color: rgba(255, 255, 255, 0.65);
    font-size: 0.9em;
    margin: 6px 0 0;
    text-align: left;
  }
  .web-panel__body ::ng-deep ion-item.input-item {
    --background: #ffffff;
    --border-color: transparent;
    --highlight-color-focused: transparent;
    --inner-padding-end: 16px;
    --padding-start: 16px;
    --min-height: 52px;
    border: 1.5px solid rgba(255, 255, 255, 0.3) !important;
    border-radius: 12px;
    margin-bottom: 0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
    transition: border-color 200ms ease, box-shadow 200ms ease;
  }
  .web-panel__body ::ng-deep ion-item.input-item.ion-focused {
    border-color: var(--ion-color-blue-default) !important;
    box-shadow: 0 0 0 3px rgba(41, 115, 162, 0.15);
  }
  .web-panel__body ::ng-deep ion-item.input-item.has-error {
    border-color: var(--input-error-color) !important;
    box-shadow: 0 0 0 1px var(--input-error-color);
  }
  .web-panel__body ::ng-deep ion-item.input-item.is-valid {
    border-color: var(--input-success-color) !important;
  }
  .web-panel__body ::ng-deep ion-label[position=floating] {
    color: var(--label-login-color, rgba(255, 255, 255, 0.7)) !important;
    font-family: "Roobert-Regular", sans-serif;
    font-size: 0.95rem;
    font-weight: 500;
  }
  .web-panel__body ::ng-deep ion-label[position=floating] ion-icon {
    vertical-align: middle;
    margin-right: 4px;
    font-size: 1.1em;
  }
  .web-panel__body ::ng-deep ion-input.custom-input {
    --padding-top: 12px;
    --padding-bottom: 12px;
    --padding-start: 0;
    font-family: "Roobert-Regular", sans-serif;
    font-size: 0.95rem;
    color: var(--text-color-2nd-login-desktop);
    --placeholder-color: var(--label-login-color);
    --placeholder-opacity: 0.5;
    height: auto;
    padding-left: 0 !important;
  }
  .web-panel__body ::ng-deep ion-input.custom-input input {
    caret-color: #000000;
  }
  .web-panel__body ::ng-deep ion-button.btn-default.access-btn {
    --background: var(--valid-btn-bg-color, #0ACB15);
    --background-hover: var(--btn-bg-color-hover, #0ACB15);
    --background-focused: var(--btn-bg-color-hover, #0ACB15);
    color: var(--valid-btn-color, #ffffff);
    --border-radius: 12px;
    --padding-top: 18px;
    --padding-bottom: 18px;
    margin: 0;
    height: auto;
    min-height: 52px;
    font-family: "Roobert-Bold", sans-serif;
    font-size: 1rem;
    letter-spacing: 0.02em;
    text-transform: none;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
    transition: transform 200ms ease, box-shadow 200ms ease;
  }
  .web-panel__body ::ng-deep ion-button.btn-default.access-btn:active {
    transform: scale(0.98);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }
  .web-panel__body ::ng-deep ion-button.btn-default.access-btn.button-disabled {
    opacity: 0.6;
    box-shadow: none;
  }
  .web-panel__body ::ng-deep ion-button.btn-default .align-loader {
    min-height: 0;
    margin: 0;
  }
  .web-panel__body ::ng-deep ion-button.btn-default.access-w-code-btn {
    --background: transparent;
    color: #ffffff;
    --border-color: rgba(255, 255, 255, 0.35);
    --border-radius: 12px;
    --padding-top: 16px;
    --padding-bottom: 16px;
    margin: 0;
    height: auto;
    min-height: 48px;
    font-family: "Roobert-Regular", sans-serif;
    font-size: 0.9rem;
    text-transform: none;
    transition: border-color 200ms ease;
  }
  .web-panel__body ::ng-deep ion-button.btn-default.access-w-code-btn:hover {
    --border-color: rgba(255, 255, 255, 0.6);
  }
  .web-panel__body ::ng-deep ion-button.btn-default.btn-outline-default {
    --border-color: rgba(255, 255, 255, 0.35);
    --border-radius: 12px;
    color: #ffffff;
  }
  .web-panel__body ::ng-deep ion-button.btn-default.btn-outline-default:hover {
    --border-color: rgba(255, 255, 255, 0.6);
  }
  .web-panel__body ::ng-deep .code-label {
    display: block;
    font-family: "Roobert-Regular", sans-serif;
    font-size: 0.82em;
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 12px;
  }
  .web-panel__body ::ng-deep .code-digit-row {
    display: flex;
    gap: 10px;
    justify-content: center;
    margin-bottom: 16px;
  }
  .web-panel__body ::ng-deep .code-digit-input {
    width: 48px;
    height: 54px;
    text-align: center;
    font-family: "Roobert-Bold", sans-serif;
    font-size: 1.3em;
    border: 1.5px solid rgba(255, 255, 255, 0.3);
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.1);
    color: #ffffff;
    outline: none;
    transition: border-color 200ms ease, background 200ms ease;
    -moz-appearance: textfield;
  }
  .web-panel__body ::ng-deep .code-digit-input::-webkit-outer-spin-button,
  .web-panel__body ::ng-deep .code-digit-input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .web-panel__body ::ng-deep .code-digit-input:focus {
    border-color: rgba(255, 255, 255, 0.6);
    background: rgba(255, 255, 255, 0.16);
  }
  .web-panel__body ::ng-deep .code-digit-input.filled {
    border-color: rgba(255, 255, 255, 0.5);
    background: rgba(255, 255, 255, 0.14);
  }
  .web-panel__body ::ng-deep .code-digit-input.has-error {
    border-color: var(--input-error-color);
  }
  .web-panel__body ::ng-deep .divider-default {
    display: none;
  }
  .web-panel__body ::ng-deep .invalid-code {
    font-size: 0.78em;
    color: #ff6b6b;
    font-weight: 500;
    text-align: left;
    margin: 6px 0 0;
    font-family: "Roobert-Regular", sans-serif;
  }
  .web-panel__body ::ng-deep .forgot-password {
    font-size: 0.85em;
    color: rgba(255, 255, 255, 0.7);
    text-decoration: underline;
    font-family: "Roobert-Regular", sans-serif;
    cursor: pointer;
    display: inline-block;
    margin-top: 4px;
  }
  .web-panel__body ::ng-deep .forgot-password:hover {
    color: #ffffff;
  }
  .web-panel__body ::ng-deep .term-conditions {
    display: flex;
    align-items: center;
    gap: 8px;
    background: transparent;
    border: none;
    font-size: 0.82em;
  }
  .web-panel__body ::ng-deep .space-condition {
    color: rgba(255, 255, 255, 0.7);
    font-family: "Roobert-Regular", sans-serif;
    padding-left: 0;
  }
  .web-panel__body ::ng-deep .space-condition a {
    color: rgba(255, 255, 255, 0.9) !important;
    text-decoration: underline;
    cursor: pointer;
  }
  .web-panel__body ::ng-deep ion-checkbox {
    --border-color: rgba(255, 255, 255, 0.35);
    --background: transparent;
    --checkmark-color: #ffffff;
    --border-radius: 4px;
    width: 20px;
    height: 20px;
    --size: 20px;
  }
  .web-panel__body ::ng-deep .timer {
    display: block;
    font-size: 0.8em;
    color: rgba(255, 255, 255, 0.5);
    font-weight: 500;
    text-align: center;
    margin-top: 8px;
    font-family: "Roobert-Regular", sans-serif;
  }
  .web-panel__body ::ng-deep .pwd-btn {
    --padding-start: 8px;
    --padding-end: 8px;
    height: 36px;
    color: var(--label-login-color);
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .web-panel {
    width: 420px;
    min-width: 420px;
  }
  .web-panel__inner {
    padding: 40px 28px;
  }
  .web-panel__scroll {
    max-width: 100%;
  }
  .web-panel__title {
    font-size: 1.35em;
  }
  .web-panel__logo {
    max-width: 76px;
    max-height: 36px;
    margin-bottom: 20px;
  }
  .web-bg__content {
    right: 420px;
    padding: 60px 0 60px 40px;
  }
  .web-bg__marketing {
    max-width: 400px;
  }
  .web-bg__logo {
    max-width: 140px;
    max-height: 56px;
    margin-bottom: 36px;
  }
  .web-bg__headline {
    font-size: 1.8em;
    margin-bottom: 36px;
  }
  .web-bg__features {
    gap: 22px;
  }
  .web-bg__feature {
    gap: 14px;
  }
  .web-bg__feature ion-icon {
    font-size: 1.7em;
  }
  .web-bg__feature p {
    font-size: 0.9em;
  }
}
@media screen and (max-width: 767px) {
  .login-background {
    position: relative;
  }
  .mobile-layout {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    justify-content: flex-end;
  }
  .mobile-top-section {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 24px;
  }
  .mobile-bottom-sheet {
    position: relative;
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-radius: 24px 24px 0 0;
    padding: 12px 24px 24px;
    box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.1);
    animation: fadeInUp 0.4s ease forwards;
  }
  .mobile-bottom-sheet::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    height: 500px;
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    pointer-events: none;
    z-index: -1;
  }
  .sheet-handle {
    width: 36px;
    height: 4px;
    border-radius: 2px;
    background: rgba(0, 0, 0, 0.2);
    margin: 0 auto 16px;
  }
  .inputs {
    width: 100%;
    height: auto;
    position: relative;
    bottom: auto;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
  }
  .default-mobile-background {
    background: transparent;
    box-shadow: none;
  }
  .invent-logo {
    width: 120px;
  }
  .banner-logo {
    max-width: 80%;
    margin: 0 auto;
  }
  ::ng-deep ion-button.btn-default.access-btn {
    --border-radius: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/login/login.page.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,aAAA;EACA,4BAAA;EACA,2BAAA;EACA,0BAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,YAAA;EACA,cAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AACF;;AAEA;EACE;IACE,UAAA;IACA,2BAAA;EACF;EACA;IACE,UAAA;IACA,wBAAA;EACF;AACF;AAEA;EACE;IACE,kBAAA;IACA,WAAA;IACA,iBAAA;IACA,aAAA;EAAF;EAGA;IACE,eAAA;IACA,QAAA;IACA,sBAAA;IACA,2BAAA;IACA,4BAAA;EADF;EAIA;IACE,kBAAA;IACA,QAAA;IACA,4GAAA;EAFF;EAUA;IACE,kBAAA;IACA,QAAA;IACA,YAAA;IACA,UAAA;IACA,aAAA;IACA,mBAAA;IACA,2BAAA;IACA,yBAAA;EARF;EAWA;IACE,gBAAA;EATF;EAYA;IAEE,gBAAA;IACA,gBAAA;IACA,mBAAA;IACA,mBAAA;EAXF;EAcA;IACE,uCAAA;IACA,gBAAA;IACA,cAAA;IACA,gBAAA;IACA,iBAAA;EAZF;EAeA;IACE,gBAAA;IACA,UAAA;IACA,SAAA;IACA,aAAA;IACA,sBAAA;IACA,SAAA;EAbF;EAgBA;IACE,aAAA;IACA,SAAA;IACA,uBAAA;EAdF;EAgBE;IACE,cAAA;IACA,gCAAA;IACA,eAAA;IACA,cAAA;EAdJ;EAiBE;IACE,cAAA;IACA,uCAAA;IACA,iBAAA;IACA,cAAA;IACA,kBAAA;EAfJ;EAkBE;IACE,0CAAA;IACA,cAAA;IACA,+BAAA;IACA,SAAA;IACA,iBAAA;EAhBJ;EAoBA;IACE,kBAAA;IACA,UAAA;IACA,YAAA;IACA,gBAAA;IACA,iBAAA;IACA,iBAAA;IACA,aAAA;IACA,sBAAA;IACA,sCAAA;EAlBF;EAqBA;IACE,OAAA;IACA,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,kBAAA;EAnBF;EAsBA;IACE,WAAA;IACA,gBAAA;IACA,cAAA;EApBF;EAuBA;IACE,mBAAA;EArBF;EAwBA;IACE,gBAAA;IACA,gBAAA;IACA,mBAAA;IACA,mBAAA;EAtBF;EA0BA;IACE,2BAAA;IACA,iBAAA;IACA,cAAA;IACA,eAAA;IACA,gBAAA;EAxBF;EA2BA;IACE,8BAAA;IACA,iBAAA;IACA,+BAAA;IACA,SAAA;IACA,gBAAA;EAzBF;EA4BA;IACE,WAAA;EA1BF;EA4BE;IACE,qBAAA;EA1BJ;EA6BE;IACE,eAAA;IACA,gBAAA;EA3BJ;EA8BE;IACE,yBAAA;IACA,0BAAA;IACA,yBAAA;EA5BJ;EA+BE;IACE,cAAA;EA7BJ;EAgCE;IACE,WAAA;IACA,eAAA;EA9BJ;EAiCE;IACE,cAAA;EA/BJ;EAiCI;IACE,yBAAA;EA/BN;EAmCE;IACE,+BAAA;EAjCJ;EAoCE;IACE,2BAAA;IACA,QAAA;EAlCJ;EAsCI;IACE,WAAA;EApCN;EAuCI;IACE,mBAAA;EArCN;EAwCI;IACE,mBAAA;EAtCN;EAyCI;IACE,gBAAA;IACA,aAAA;IACA,sBAAA;IACA,SAAA;EAvCN;EA0CI;IACE,uCAAA;IACA,iBAAA;IACA,cAAA;IACA,SAAA;IACA,gBAAA;EAxCN;EA2CI;IACE,gCAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;EAzCN;EA4CI;IACE,qBAAA;IACA,2BAAA;IACA,sCAAA;IACA,yBAAA;IACA,qBAAA;IACA,kBAAA;IACA,uDAAA;IACA,mBAAA;IACA,gBAAA;IACA,yCAAA;IACA,0DAAA;EA1CN;EA6CI;IACE,sDAAA;IACA,8CAAA;EA3CN;EA8CI;IACE,iDAAA;IACA,8CAAA;EA5CN;EA+CI;IACE,mDAAA;EA7CN;EAgDI;IACE,oEAAA;IACA,0CAAA;IACA,kBAAA;IACA,gBAAA;EA9CN;EAiDI;IACE,sBAAA;IACA,iBAAA;IACA,gBAAA;EA/CN;EAkDI;IACE,mBAAA;IACA,sBAAA;IACA,kBAAA;IACA,0CAAA;IACA,kBAAA;IACA,0CAAA;IACA,6CAAA;IACA,0BAAA;IACA,YAAA;IACA,0BAAA;EAhDN;EAmDI;IACE,oBAAA;EAjDN;EAoDI;IACE,gDAAA;IACA,sDAAA;IACA,wDAAA;IACA,sCAAA;IACA,qBAAA;IACA,mBAAA;IACA,sBAAA;IACA,SAAA;IACA,YAAA;IACA,gBAAA;IACA,uCAAA;IACA,eAAA;IACA,sBAAA;IACA,oBAAA;IACA,yCAAA;IACA,uDAAA;EAlDN;EAqDI;IACE,sBAAA;IACA,yCAAA;EAnDN;EAsDI;IACE,YAAA;IACA,gBAAA;EApDN;EAuDI;IACE,aAAA;IACA,SAAA;EArDN;EAwDI;IACE,yBAAA;IACA,cAAA;IACA,yCAAA;IACA,qBAAA;IACA,mBAAA;IACA,sBAAA;IACA,SAAA;IACA,YAAA;IACA,gBAAA;IACA,0CAAA;IACA,iBAAA;IACA,oBAAA;IACA,mCAAA;EAtDN;EAyDI;IACE,wCAAA;EAvDN;EA0DI;IACE,yCAAA;IACA,qBAAA;IACA,cAAA;EAxDN;EA2DI;IACE,wCAAA;EAzDN;EA4DI;IACE,cAAA;IACA,0CAAA;IACA,iBAAA;IACA,+BAAA;IACA,mBAAA;EA1DN;EA6DI;IACE,aAAA;IACA,SAAA;IACA,uBAAA;IACA,mBAAA;EA3DN;EA8DI;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,uCAAA;IACA,gBAAA;IACA,4CAAA;IACA,mBAAA;IACA,oCAAA;IACA,cAAA;IACA,aAAA;IACA,0DAAA;IACA,0BAAA;EA5DN;EA+DI;;IAEE,wBAAA;IACA,SAAA;EA7DN;EAgEI;IACE,sCAAA;IACA,qCAAA;EA9DN;EAiEI;IACE,sCAAA;IACA,qCAAA;EA/DN;EAkEI;IACE,sCAAA;EAhEN;EAmEI;IACE,aAAA;EAjEN;EAoEI;IACE,iBAAA;IACA,cAAA;IACA,gBAAA;IACA,gBAAA;IACA,eAAA;IACA,0CAAA;EAlEN;EAqEI;IACE,iBAAA;IACA,+BAAA;IACA,0BAAA;IACA,0CAAA;IACA,eAAA;IACA,qBAAA;IACA,eAAA;EAnEN;EAsEI;IACE,cAAA;EApEN;EAuEI;IACE,aAAA;IACA,mBAAA;IACA,QAAA;IACA,uBAAA;IACA,YAAA;IACA,iBAAA;EArEN;EAwEI;IACE,+BAAA;IACA,0CAAA;IACA,eAAA;EAtEN;EAwEM;IACE,0CAAA;IACA,0BAAA;IACA,eAAA;EAtER;EA0EI;IACE,yCAAA;IACA,yBAAA;IACA,0BAAA;IACA,oBAAA;IACA,WAAA;IACA,YAAA;IACA,YAAA;EAxEN;EA2EI;IACE,cAAA;IACA,gBAAA;IACA,+BAAA;IACA,gBAAA;IACA,kBAAA;IACA,eAAA;IACA,0CAAA;EAzEN;EA4EI;IACE,oBAAA;IACA,kBAAA;IACA,YAAA;IACA,+BAAA;EA1EN;AACF;AA+EA;EACE;IACE,YAAA;IACA,gBAAA;EA7EF;EAgFA;IACE,kBAAA;EA9EF;EAiFA;IACE,eAAA;EA/EF;EAkFA;IACE,iBAAA;EAhFF;EAmFA;IACE,eAAA;IACA,gBAAA;IACA,mBAAA;EAjFF;EAoFA;IACE,YAAA;IACA,yBAAA;EAlFF;EAqFA;IACE,gBAAA;EAnFF;EAsFA;IACE,gBAAA;IACA,gBAAA;IACA,mBAAA;EApFF;EAuFA;IACE,gBAAA;IACA,mBAAA;EArFF;EAwFA;IACE,SAAA;EAtFF;EAyFA;IACE,SAAA;EAvFF;EAyFE;IACE,gBAAA;EAvFJ;EA0FE;IACE,gBAAA;EAxFJ;AACF;AA4FA;EACE;IACE,kBAAA;EA1FF;EA6FA;IACE,aAAA;IACA,sBAAA;IACA,gBAAA;IACA,yBAAA;EA3FF;EA8FA;IACE,OAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,kBAAA;EA5FF;EA+FA;IACE,kBAAA;IAEA,2BAAA;IACA,mCAAA;IACA,4BAAA;IACA,uBAAA;IACA,0CAAA;IACA,sCAAA;EA9FF;EAiGA;IACE,WAAA;IACA,kBAAA;IACA,SAAA;IACA,OAAA;IACA,QAAA;IACA,aAAA;IAEA,2BAAA;IACA,mCAAA;IACA,oBAAA;IACA,WAAA;EAhGF;EAmGA;IACE,WAAA;IACA,WAAA;IACA,kBAAA;IACA,8BAAA;IACA,mBAAA;EAjGF;EAoGA;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,YAAA;IACA,gBAAA;IACA,uBAAA;IACA,gBAAA;EAlGF;EAqGA;IACE,uBAAA;IACA,gBAAA;EAnGF;EAsGA;IACE,YAAA;EApGF;EAuGA;IACE,cAAA;IACA,cAAA;EArGF;EAyGE;IACE,qBAAA;EAvGJ;AACF","sourcesContent":[".login-background{\n  width: 100% !important;\n  height: 100vh;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100% 100%;\n}\n\n.logo {\n  margin: 0 auto;\n}\n\n.invent-logo {\n  width: 150px;\n  margin: 0 auto;\n  display: block;\n}\n\n.banner-logo {\n  width: 100%;\n  margin: 0 auto;\n  display: block;\n  max-width: 600px;\n  position: relative;\n}\n\nion-title {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  text-transform: uppercase;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(16px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media screen and (min-width: 768px) {\n  .web-layout {\n    position: relative;\n    width: 100%;\n    min-height: 100vh;\n    display: flex;\n  }\n\n  .web-bg {\n    position: fixed;\n    inset: 0;\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n  }\n\n  .web-bg__overlay {\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(\n      90deg,\n      rgba(0, 0, 0, 0.55) 0%,\n      rgba(0, 0, 0, 0.15) 50%,\n      rgba(0, 0, 0, 0.6) 100%\n    );\n  }\n\n  .web-bg__content {\n    position: absolute;\n    inset: 0;\n    right: 560px;\n    z-index: 2;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    padding: 80px 0 80px 72px;\n  }\n\n  .web-bg__marketing {\n    max-width: 560px;\n  }\n\n  .web-bg__logo {\n    // filter: brightness(0) invert(1);\n    max-width: 180px;\n    max-height: 72px;\n    object-fit: contain;\n    margin-bottom: 48px;\n  }\n\n  .web-bg__headline {\n    font-family: 'Roobert-Bold', sans-serif;\n    font-size: 2.4em;\n    color: #ffffff;\n    margin: 0 0 48px;\n    line-height: 1.25;\n  }\n\n  .web-bg__features {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 28px;\n  }\n\n  .web-bg__feature {\n    display: flex;\n    gap: 18px;\n    align-items: flex-start;\n\n    ion-icon {\n      font-size: 2em;\n      color: rgba(255, 255, 255, 0.75);\n      margin-top: 2px;\n      flex-shrink: 0;\n    }\n\n    strong {\n      display: block;\n      font-family: 'Roobert-Bold', sans-serif;\n      font-size: 1.15em;\n      color: #ffffff;\n      margin-bottom: 4px;\n    }\n\n    p {\n      font-family: 'Roobert-Regular', sans-serif;\n      font-size: 1em;\n      color: rgba(255, 255, 255, 0.6);\n      margin: 0;\n      line-height: 1.55;\n    }\n  }\n\n  .web-panel {\n    position: relative;\n    z-index: 1;\n    width: 560px;\n    min-width: 560px;\n    min-height: 100vh;\n    margin-left: auto;\n    display: flex;\n    flex-direction: column;\n    animation: fadeInUp 0.5s ease forwards;\n  }\n\n  .web-panel__inner {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 48px 56px;\n  }\n\n  .web-panel__scroll {\n    width: 100%;\n    max-width: 400px;\n    margin: 0 auto;\n  }\n\n  .web-panel__top {\n    margin-bottom: 32px;\n  }\n\n  .web-panel__logo {\n    max-width: 100px;\n    max-height: 44px;\n    object-fit: contain;\n    margin-bottom: 28px;\n    //filter: brightness(0) invert(1);\n  }\n\n  .web-panel__title {\n    font-family: 'Roobert-Bold';\n    font-size: 1.65em;\n    color: #ffffff;\n    margin: 0 0 8px;\n    line-height: 1.3;\n  }\n\n  .web-panel__desc {\n    font-family: 'Roobert-Regular';\n    font-size: 0.95em;\n    color: rgba(255, 255, 255, 0.7);\n    margin: 0;\n    line-height: 1.5;\n  }\n\n  .web-panel__body {\n    width: 100%;\n\n    ion-grid {\n      --ion-grid-padding: 0;\n    }\n\n    ion-row {\n      padding-left: 0;\n      padding-right: 0;\n    }\n\n    ion-col {\n      flex: 0 0 100% !important;\n      max-width: 100% !important;\n      margin-left: 0 !important;\n    }\n\n    .padding-top-40 {\n      padding-top: 0;\n    }\n\n    .btn-default {\n      width: 100%;\n      max-width: 100%;\n    }\n\n    .color-1st-screen {\n      color: #ffffff;\n\n      a {\n        color: #ffffff !important;\n      }\n    }\n\n    .forgot-password {\n      color: rgba(255, 255, 255, 0.8);\n    }\n\n    .term-conditions {\n      justify-content: flex-start;\n      gap: 2px;\n    }\n\n    ::ng-deep {\n      .login-form {\n        width: 100%;\n      }\n\n      .login-form__header {\n        margin-bottom: 28px;\n      }\n\n      .login-form__field {\n        margin-bottom: 16px;\n      }\n\n      .login-form__actions {\n        margin-top: 24px;\n        display: flex;\n        flex-direction: column;\n        gap: 12px;\n      }\n\n      .login-title {\n        font-family: 'Roobert-Bold', sans-serif;\n        font-size: 1.35em;\n        color: #ffffff;\n        margin: 0;\n        text-align: left;\n      }\n\n      .explanation-txt {\n        color: rgba(255, 255, 255, 0.65);\n        font-size: 0.9em;\n        margin: 6px 0 0;\n        text-align: left;\n      }\n\n      ion-item.input-item {\n        --background: #ffffff;\n        --border-color: transparent;\n        --highlight-color-focused: transparent;\n        --inner-padding-end: 16px;\n        --padding-start: 16px;\n        --min-height: 52px;\n        border: 1.5px solid rgba(255, 255, 255, 0.3) !important;\n        border-radius: 12px;\n        margin-bottom: 0;\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n        transition: border-color 200ms ease, box-shadow 200ms ease;\n      }\n\n      ion-item.input-item.ion-focused {\n        border-color: var(--ion-color-blue-default) !important;\n        box-shadow: 0 0 0 3px rgba(41, 115, 162, 0.15);\n      }\n\n      ion-item.input-item.has-error {\n        border-color: var(--input-error-color) !important;\n        box-shadow: 0 0 0 1px var(--input-error-color);\n      }\n\n      ion-item.input-item.is-valid {\n        border-color: var(--input-success-color) !important;\n      }\n\n      ion-label[position=\"floating\"] {\n        color: var(--label-login-color, rgba(255, 255, 255, 0.7)) !important;\n        font-family: 'Roobert-Regular', sans-serif;\n        font-size: 0.95rem;\n        font-weight: 500;\n      }\n\n      ion-label[position=\"floating\"] ion-icon {\n        vertical-align: middle;\n        margin-right: 4px;\n        font-size: 1.1em;\n      }\n\n      ion-input.custom-input {\n        --padding-top: 12px;\n        --padding-bottom: 12px;\n        --padding-start: 0;\n        font-family: 'Roobert-Regular', sans-serif;\n        font-size: 0.95rem;\n        color: var(--text-color-2nd-login-desktop);\n        --placeholder-color: var(--label-login-color);\n        --placeholder-opacity: 0.5;\n        height: auto;\n        padding-left: 0 !important;\n      }\n\n      ion-input.custom-input input {\n        caret-color: #000000;\n      }\n\n      ion-button.btn-default.access-btn {\n        --background: var(--valid-btn-bg-color, #0ACB15);\n        --background-hover: var(--btn-bg-color-hover, #0ACB15);\n        --background-focused: var(--btn-bg-color-hover, #0ACB15);\n        color: var(--valid-btn-color, #ffffff);\n        --border-radius: 12px;\n        --padding-top: 18px;\n        --padding-bottom: 18px;\n        margin: 0;\n        height: auto;\n        min-height: 52px;\n        font-family: 'Roobert-Bold', sans-serif;\n        font-size: 1rem;\n        letter-spacing: 0.02em;\n        text-transform: none;\n        box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);\n        transition: transform 200ms ease, box-shadow 200ms ease;\n      }\n\n      ion-button.btn-default.access-btn:active {\n        transform: scale(0.98);\n        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n      }\n\n      ion-button.btn-default.access-btn.button-disabled {\n        opacity: 0.6;\n        box-shadow: none;\n      }\n\n      ion-button.btn-default .align-loader {\n        min-height: 0;\n        margin: 0;\n      }\n\n      ion-button.btn-default.access-w-code-btn {\n        --background: transparent;\n        color: #ffffff;\n        --border-color: rgba(255, 255, 255, 0.35);\n        --border-radius: 12px;\n        --padding-top: 16px;\n        --padding-bottom: 16px;\n        margin: 0;\n        height: auto;\n        min-height: 48px;\n        font-family: 'Roobert-Regular', sans-serif;\n        font-size: 0.9rem;\n        text-transform: none;\n        transition: border-color 200ms ease;\n      }\n\n      ion-button.btn-default.access-w-code-btn:hover {\n        --border-color: rgba(255, 255, 255, 0.6);\n      }\n\n      ion-button.btn-default.btn-outline-default {\n        --border-color: rgba(255, 255, 255, 0.35);\n        --border-radius: 12px;\n        color: #ffffff;\n      }\n\n      ion-button.btn-default.btn-outline-default:hover {\n        --border-color: rgba(255, 255, 255, 0.6);\n      }\n\n      .code-label {\n        display: block;\n        font-family: 'Roobert-Regular', sans-serif;\n        font-size: 0.82em;\n        color: rgba(255, 255, 255, 0.7);\n        margin-bottom: 12px;\n      }\n\n      .code-digit-row {\n        display: flex;\n        gap: 10px;\n        justify-content: center;\n        margin-bottom: 16px;\n      }\n\n      .code-digit-input {\n        width: 48px;\n        height: 54px;\n        text-align: center;\n        font-family: 'Roobert-Bold', sans-serif;\n        font-size: 1.3em;\n        border: 1.5px solid rgba(255, 255, 255, 0.3);\n        border-radius: 12px;\n        background: rgba(255, 255, 255, 0.1);\n        color: #ffffff;\n        outline: none;\n        transition: border-color 200ms ease, background 200ms ease;\n        -moz-appearance: textfield;\n      }\n\n      .code-digit-input::-webkit-outer-spin-button,\n      .code-digit-input::-webkit-inner-spin-button {\n        -webkit-appearance: none;\n        margin: 0;\n      }\n\n      .code-digit-input:focus {\n        border-color: rgba(255, 255, 255, 0.6);\n        background: rgba(255, 255, 255, 0.16);\n      }\n\n      .code-digit-input.filled {\n        border-color: rgba(255, 255, 255, 0.5);\n        background: rgba(255, 255, 255, 0.14);\n      }\n\n      .code-digit-input.has-error {\n        border-color: var(--input-error-color);\n      }\n\n      .divider-default {\n        display: none;\n      }\n\n      .invalid-code {\n        font-size: 0.78em;\n        color: #ff6b6b;\n        font-weight: 500;\n        text-align: left;\n        margin: 6px 0 0;\n        font-family: 'Roobert-Regular', sans-serif;\n      }\n\n      .forgot-password {\n        font-size: 0.85em;\n        color: rgba(255, 255, 255, 0.7);\n        text-decoration: underline;\n        font-family: 'Roobert-Regular', sans-serif;\n        cursor: pointer;\n        display: inline-block;\n        margin-top: 4px;\n      }\n\n      .forgot-password:hover {\n        color: #ffffff;\n      }\n\n      .term-conditions {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n        background: transparent;\n        border: none;\n        font-size: 0.82em;\n      }\n\n      .space-condition {\n        color: rgba(255, 255, 255, 0.7);\n        font-family: 'Roobert-Regular', sans-serif;\n        padding-left: 0;\n\n        a {\n          color: rgba(255, 255, 255, 0.9) !important;\n          text-decoration: underline;\n          cursor: pointer;\n        }\n      }\n\n      ion-checkbox {\n        --border-color: rgba(255, 255, 255, 0.35);\n        --background: transparent;\n        --checkmark-color: #ffffff;\n        --border-radius: 4px;\n        width: 20px;\n        height: 20px;\n        --size: 20px;\n      }\n\n      .timer {\n        display: block;\n        font-size: 0.8em;\n        color: rgba(255, 255, 255, 0.5);\n        font-weight: 500;\n        text-align: center;\n        margin-top: 8px;\n        font-family: 'Roobert-Regular', sans-serif;\n      }\n\n      .pwd-btn {\n        --padding-start: 8px;\n        --padding-end: 8px;\n        height: 36px;\n        color: var(--label-login-color);\n      }\n    }\n  }\n}\n\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  .web-panel {\n    width: 420px;\n    min-width: 420px;\n  }\n\n  .web-panel__inner {\n    padding: 40px 28px;\n  }\n\n  .web-panel__scroll {\n    max-width: 100%;\n  }\n\n  .web-panel__title {\n    font-size: 1.35em;\n  }\n\n  .web-panel__logo {\n    max-width: 76px;\n    max-height: 36px;\n    margin-bottom: 20px;\n  }\n\n  .web-bg__content {\n    right: 420px;\n    padding: 60px 0 60px 40px;\n  }\n\n  .web-bg__marketing {\n    max-width: 400px;\n  }\n\n  .web-bg__logo {\n    max-width: 140px;\n    max-height: 56px;\n    margin-bottom: 36px;\n  }\n\n  .web-bg__headline {\n    font-size: 1.8em;\n    margin-bottom: 36px;\n  }\n\n  .web-bg__features {\n    gap: 22px;\n  }\n\n  .web-bg__feature {\n    gap: 14px;\n\n    ion-icon {\n      font-size: 1.7em;\n    }\n\n    p {\n      font-size: 0.9em;\n    }\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .login-background {\n    position: relative;\n  }\n\n  .mobile-layout {\n    display: flex;\n    flex-direction: column;\n    min-height: 100%;\n    justify-content: flex-end;\n  }\n\n  .mobile-top-section {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 40px 24px;\n  }\n\n  .mobile-bottom-sheet {\n    position: relative;\n    // background: rgba(255, 255, 255, 0.85);\n    backdrop-filter: blur(20px);\n    -webkit-backdrop-filter: blur(20px);\n    border-radius: 24px 24px 0 0;\n    padding: 12px 24px 24px;\n    box-shadow: 0 -4px 24px rgba(0, 0, 0, 0.1);\n    animation: fadeInUp 0.4s ease forwards;\n  }\n\n  .mobile-bottom-sheet::after {\n    content: '';\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    height: 500px;\n    // background: rgba(255, 255, 255, 0.85);\n    backdrop-filter: blur(20px);\n    -webkit-backdrop-filter: blur(20px);\n    pointer-events: none;\n    z-index: -1;\n  }\n\n  .sheet-handle {\n    width: 36px;\n    height: 4px;\n    border-radius: 2px;\n    background: rgba(0, 0, 0, 0.2);\n    margin: 0 auto 16px;\n  }\n\n  .inputs {\n    width: 100%;\n    height: auto;\n    position: relative;\n    bottom: auto;\n    border-radius: 0;\n    background: transparent;\n    box-shadow: none;\n  }\n\n  .default-mobile-background {\n    background: transparent;\n    box-shadow: none;\n  }\n\n  .invent-logo {\n    width: 120px;\n  }\n\n  .banner-logo {\n    max-width: 80%;\n    margin: 0 auto;\n  }\n\n  ::ng-deep {\n    ion-button.btn-default.access-btn {\n      --border-radius: 12px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
